import dayjs from 'dayjs';
import { HYDRATE } from 'next-redux-wrapper';

import { IVasInfo } from '@r1-frontend/api-domru/api-profile/v1/vas/dto/ResponseDto';

import { InferValueTypes, THydrateAction } from '~/src/store';
import * as ActionCreators from '~/src/store/actionCreators/vas';
import {
    VAS_ANTIVIRUS_LOAD_ERROR,
    VAS_ANTIVIRUS_LOADED,
    VAS_ANTIVIRUS_LOADING,
    VAS_DISABLING_STATUS_CHANGE,
    VAS_GAMERSBASE_URL,
    VAS_LOAD_ERROR,
    VAS_LOADED,
    VAS_LOADING,
    VAS_SET_VAS_ERROR,
    VAS_SUBSCRIPTIONS_LOAD_ERROR,
    VAS_SUBSCRIPTIONS_LOADED,
    VAS_SUBSCRIPTIONS_LOADING,
} from '~/src/store/actionTypes/vas';

export enum EVasDisablingStatus {
    default,
    disabling,
    disablingError,
    disabled
}

export interface IVasStore {
    isLoading: boolean,
    vasDisablingStatus: EVasDisablingStatus,
    errorMessage: string | null,
    default: IVasInfo[],
    antivirus: IVasInfo[],
    subscriptions: IVasInfo[],
    loaded: number | null,
    gamersBaseUrl: string | null,
    isLoadingAntivirus: boolean,
    isLoadingSubscriptions: boolean,
    antivirusLoaded: number | null,
}

const INITIAL_STATE: IVasStore = {
    vasDisablingStatus: EVasDisablingStatus.default,
    errorMessage: null,
    loaded: null,
    isLoading: false,
    default: [],
    antivirus: [],
    subscriptions: [],
    gamersBaseUrl: null,
    isLoadingAntivirus: false,
    isLoadingSubscriptions: false,
    antivirusLoaded: null,
};

type TActions = ReturnType<InferValueTypes<typeof ActionCreators>> | THydrateAction;

export default function reducer(state = INITIAL_STATE, action: TActions): IVasStore {
    switch (action.type) {
        case HYDRATE:
            return action.payload.vas;
        case VAS_LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case VAS_ANTIVIRUS_LOADING:
            return {
                ...state,
                isLoadingAntivirus: true,
            };
        case VAS_SUBSCRIPTIONS_LOADING:
            return {
                ...state,
                isLoadingSubscriptions: true,
            };
        case VAS_LOADED:
            return {
                ...state,
                isLoading: false,
                default: action.payload,
                loaded: dayjs().unix(),
            };
        case VAS_ANTIVIRUS_LOADED:
            return {
                ...state,
                isLoadingAntivirus: false,
                antivirus: action.payload,
                antivirusLoaded: dayjs().unix(),
            };
        case VAS_SUBSCRIPTIONS_LOADED:
            return {
                ...state,
                isLoadingSubscriptions: false,
                subscriptions: action.payload,
            };
        case VAS_LOAD_ERROR:
            return {
                ...state,
                isLoading: false,
            };
        case VAS_ANTIVIRUS_LOAD_ERROR:
            return {
                ...state,
                isLoadingAntivirus: false,
                antivirusLoaded: dayjs().unix(),
            };
        case VAS_SUBSCRIPTIONS_LOAD_ERROR:
            return {
                ...state,
                isLoadingSubscriptions: false,
            };
        case VAS_DISABLING_STATUS_CHANGE:
            return {
                ...state,
                vasDisablingStatus: action.payload,
            };
        case VAS_SET_VAS_ERROR:
            return {
                ...state,
                errorMessage: action.payload,
            };
        case VAS_GAMERSBASE_URL:
            return {
                ...state,
                gamersBaseUrl: action.payload,
            };
        default:
            return state;
    }
}
